import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound, Copy, Loader2 } from "lucide-react";

export function ResetStaffPasswordButton({ staff }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  async function go() {
    setBusy(true);
    try { const { data } = await api.post(`/staff-mgmt/staff/${staff.id}/reset-password`); setRes(data); } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  const close = () => { setOpen(false); setRes(null); };
  return (
    <>
      <Button data-testid="staff-reset-password" variant="outline" onClick={() => setOpen(true)}><KeyRound size={15} className="mr-1" /> Reset password</Button>
      <Dialog open={open} onOpenChange={(v) => { if (!v) close(); }}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle className="font-display">Reset password • {staff.name}</DialogTitle></DialogHeader>
          {!res ? (<>
            <p className="text-sm text-slate-600">A new temporary password will be created. {staff.name} is signed out everywhere and must choose their own password at next sign-in.</p>
            <Button data-testid="staff-reset-confirm" onClick={go} disabled={busy} className="btn-brand w-full">{busy && <Loader2 size={14} className="animate-spin mr-1" />}Create temporary password</Button>
          </>) : (<div className="space-y-3 animate-in fade-in duration-300">
            <p className="text-sm text-slate-600">Share these with {staff.name}. This password is shown only once.</p>
            <div className="rounded-xl bg-violet-50 p-3 text-sm space-y-1">
              <div>Login: <b data-testid="staff-reset-email">{res.email}</b></div>
              <div className="flex items-center gap-2">Temporary password: <b data-testid="staff-reset-temp" className="font-mono text-violet-800">{res.temporary_password}</b>
                <button data-testid="staff-reset-copy" onClick={() => navigator.clipboard.writeText(res.temporary_password).then(() => toast.success("Copied"))} className="text-violet-600"><Copy size={14} /></button></div>
            </div>
            <Button variant="outline" onClick={close} className="w-full" data-testid="staff-reset-done">Done</Button>
          </div>)}
        </DialogContent>
      </Dialog>
    </>
  );
}
